var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c("div", { staticClass: "ml-1 mr-1 pt-1 pb-1 mb-0" }, [
        _c("div", {
          staticClass: "breakAll font-medium-3 text-dark text-bold-700",
          domProps: {
            innerHTML: _vm._s(
              this.$options.filters.nl2br(this.data.title, true)
            ),
          },
        }),
        _vm._v(" "),
        _c("div", {
          directives: [{ name: "linkified", rawName: "v-linkified" }],
          staticClass: "breakAll pt-05 pb-05",
          domProps: {
            innerHTML: _vm._s(
              this.$options.filters.nl2br(this.data.body, true)
            ),
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-right p-05 border-top" }, [
        _c(
          "a",
          {
            staticClass: "ml-auto text-bold-700 font-small-3",
            attrs: { href: "/question/" + _vm.data.slug },
          },
          [
            _vm._v(_vm._s(_vm.__("question.view_this_question")) + " "),
            _c("i", { staticClass: "feather icon-chevron-right" }),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }